export const COMMITS = '/general/COMMITS';
